var exports = {
  "kL": "EmojiTooltipContent.module__container___RzBHbD",
  "Zg": "EmojiTooltipContent.module__emoji___RzBHbD",
  "FS": "EmojiTooltipContent.module__textContainer___RzBHbD",
  "Lq": "EmojiTooltipContent.module__loading___RzBHbD",
  "W$": "EmojiTooltipContent.module__subtext___RzBHbD",
  "vW": "EmojiTooltipContent.module__inner___RzBHbD",
};

module.exports = exports;
